





















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as Y from 'yjs'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import ButtonCheck from 'components/presenter/item/topic/viewer/ButtonCheck.vue'
import GapsInput from 'components/presenter/item/topic/viewer/GapsInput.vue'
import { QuizSlideResult } from 'src/assets/AttendeeItemData'

@Component({
  components: {
    MarkdownViewerCrdt,
    ButtonCheck,
    GapsInput
  }
})
export default class ItemTopicViewerGaps extends Vue {
  definition: Array<string|number> = []
  response: { [key: string]: string } = {}

  @Prop({ default: false })
  readonly feedbackButtonShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonShowAlways!: boolean

  @Prop({ default: false })
  readonly feedbackButtonOn!: boolean

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly result!: QuizSlideResult | undefined

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: { [key: string]: string }

  @Watch('value', { immediate: true })
  update (value: { [key: string]: string }) {
    this.response = value ? Object.assign({}, value) : {}
  }

  get text () {
    return this.slide?.text?.getText()
  }

  get gaps () {
    return this.slide?.gaps?.getText() || new Y.Text()
  }

  get canRespond () {
    return !(this.readonly || this.feedbackButtonOn)
  }

  beforeDestroy () {
    this.gaps.unobserve(this.observer)
  }

  @Watch('gaps', { immediate: true })
  init (gaps: Y.Text | undefined, prev: Y.Text | undefined) {
    prev?.unobserve(this.observer)
    gaps?.observe(this.observer)
    this.observer()
  }

  observer () {
    let counter = 0
    this.definition = (this.gaps?.toString() || '').split(/(\[\[\]\])/).map((gap: string) => gap === '[[]]' ? counter++ : gap)
  }

  respond (input: string, value: string | null) {
    if (value) {
      this.$set(this.response, input, value)
    } else {
      this.$delete(this.response, input)
    }
    this.$emit('input', Object.keys(this.response).length ? this.response : undefined)
  }
}
